// Stroke icons from the editor toolbar design (24px grid, scaled down)
const paths = {
  textStyle: `M5 6V4h14v2M12 4v16M9 20h6`,
  chevronDown: `M6 9l6 6 6-6`,
  alignLeft: `M4 6h16M4 12h10M4 18h14`,
  alignCenter: `M4 6h16M7 12h10M5 18h14`,
  alignRight: `M4 6h16M10 12h10M6 18h14`,
  alignJustify: `M4 6h16M4 12h16M4 18h16`,
  link: `M10 14a4 4 0 005.66 0l3-3a4 4 0 00-5.66-5.66l-1 1M14 10a4 4 0 00-5.66 0l-3 3a4 4 0 005.66 5.66l1-1`,
  divider: `M3 12h18`,
  button: `M6 7h12a3 3 0 013 3v4a3 3 0 01-3 3H6a3 3 0 01-3-3v-4a3 3 0 013-3zM8 12h8`,
  lineBreak: `M20 5v6a3 3 0 01-3 3H5M9 10l-4 4 4 4`,
  image: `M4 5h16v14H4zM4 15l4-4 4 4 3-3 5 5M15 9h.01`,
  field: `M8 4H7a2 2 0 00-2 2v4a2 2 0 01-2 2 2 2 0 012 2v4a2 2 0 002 2h1M16 4h1a2 2 0 012 2v4a2 2 0 002 2 2 2 0 00-2 2v4a2 2 0 01-2 2h-1`,
  bold: `M7 5h6a3.5 3.5 0 010 7H7zM7 12h7a3.5 3.5 0 010 7H7z`,
  italic: `M19 4h-9M14 20H5M15 4L9 20`,
  underline: `M6 4v6a6 6 0 0012 0V4M4 20h16`,
  textColour: `M6 20L12 4l6 16M8.5 14h7`,
  grip: `M9 6h.01M15 6h.01M9 12h.01M15 12h.01M9 18h.01M15 18h.01`,
};

export function EditorIcon({ name, size = 15, className }: { name: keyof typeof paths; size?: number; className?: string }) {
  return (
    <svg
      width={ size }
      height={ size }
      viewBox={ `0 0 24 24` }
      fill={ `none` }
      stroke={ `currentColor` }
      strokeWidth={ name === `bold` ? 2.4 : name === `grip` ? 3 : 1.9 }
      strokeLinecap={ `round` }
      strokeLinejoin={ `round` }
      className={ className }
      aria-hidden={ `true` }
    >
      <path d={ paths[name] } />
    </svg>
  );
}
